import styled from 'styled-components';

import colors from '@wecasa/common/src/utils/colors';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';

const StyledSlot = styled.div<{
  $isPrimary: boolean;
}>`
  width: 45px;
  padding: 3px 8px;
  margin: 0 5px 5px 0;
  background-color: ${({ $isPrimary }) => ($isPrimary ? colors.orange100 : colors.neutral20)};
  border-radius: 2px;
  text-align: center;
`;

type SlotProps = {
  className?: string;
  text: string;
  isPrimary: boolean;
  label: string;
};

const Slot = ({ text, isPrimary, label, className }: SlotProps) => (
  <StyledSlot className={className} $isPrimary={isPrimary} aria-label={label}>
    <Text.SMMedium centered color={isPrimary ? colors.white100 : colors.neutral100}>
      {text}
    </Text.SMMedium>
  </StyledSlot>
);

export default Slot;
